<template>
  <div>
    <table class="">
      <tr v-for="(batch, index) in data.batches" :key="index">
        <td>
          <label>Batch Number</label>
          <input
            type="text"
            class="form-control"
            placeholder="Batch Number"
            v-model="batch.BatchNumber"
            required
          />
        </td>
        <td>
          <label>Quantity</label>
          <input
            type="text"
            class="form-control"
            placeholder="Quantity"
            v-model="batch.Quantity"
            required
          />
        </td>
        <td>
          <label>MFGDate</label>
          <input
            type="date"
            class="form-control"
            placeholder="MFG"
            v-model="batch.MFGDate"
          />
        </td>
        <td>
          <label>Expiry Date</label>
          <input
            type="date"
            class="form-control"
            placeholder="Expiry"
            v-model="batch.ExpiryDate"
          />
        </td>
        <td>
          <a
            class="mt-5 btn btn-sm btn-danger text-white"
            @click="removeRow(index, batch)"
            >Delete</a
          >
        </td>
      </tr>
      <tr>
        <td colspan="5">
          <div class="text-right">
            <span
              class="btn btn-sm btn-info mt-3 btn-add-new-batch"
              data-toggle="tooltip"
              data-placement="top"
              title="Add new Batch"
              v-on:click="addNewBatchRow(ItemId)"
            >
              <i class="fa fa-plus-circle"></i>
            </span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "delivery-challan-item-edit-batch",
  props: ["ItemId", "deliveryChallanItemId"],
  data() {
    return {
      data: {
        ItemId: this.ItemId,
        batches: [
          {
            Id: null,
            BatchNumber: null,
            Quantity: 0,
            MFGDate: null,
            ExpiryDate: null,
            isNew: true,
          },
        ],
      },

      URLDcEditItemBatchList: "delivery-challan/batches/list",
      URLDcEditItemBatchDelete: 'delivery-challan/deleteBatch'
    };
  },
  methods: {
    addNewBatchRow: function (itemId) {
      this.data.ItemId = itemId;
      this.data.batches.push({
        Id: null,
        BatchNumber: null,
        Quantity: 0,
        MFGDate: null,
        ExpiryDate: null,
        isNew: true,
      });

      console.log(this.data);

      this.data.batches = this.checkUniqueBatches(
        this.data.batches,
        "BatchNumber"
      );
    },
    removeRow: function (index, row) {
     
      if (row.isNew) {
        return this.data.batches.splice(index, 1);
      }
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          // getting items of posted purchase order
          axios
            .get(this.URLDcEditItemBatchDelete + "/" + row.Id)
            .then((response) => {
              Swal.fire(
                "Deleted!",
                "Your item batch has been deleted.",
                "success"
              );
              this.data.batches.splice(index, 1);
            })
            .catch((error) => {
              this.errored = true;
            })
            .finally(() => (this.loading = false));
        }
      });
    },
    checkUniqueBatches: function (arr, key) {
      var uniqueBatches = [
        ...new Map(arr.map((item) => [item[key], item])).values(),
      ];
      return uniqueBatches;
    },
    callDcItemBatchesFromApi: function (ItemId) {
      // getting items of posted purchase order
      axios
        .get(this.URLDcEditItemBatchList + "/" + ItemId)
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
  },
  mounted() {
    this.callDcItemBatchesFromApi(this.ItemId);
  },
};
</script>

<style lang="scss" scoped>
</style>